module.exports = __webpack_public_path__ + "img/btn_select.db8847ca.svg";